(ns manage.ad-variant.creation.feed.modal
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/InputAdornment$default" :as InputAdornment]
            ["@mui/material/MenuItem$default" :as MenuItem]
            ["@mui/material/Select$default" :as Select]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Switch$default" :as Switch]
            ["@mui/material/Typography$default" :as Typography]
            ["@mui/x-date-pickers-pro" :refer [LocalizationProvider]]
            ["@mui/x-date-pickers-pro/AdapterMoment" :refer [AdapterMoment]]
            ["@mui/x-date-pickers/TimePicker" :refer [TimePicker]]
            ["moment-timezone$default" :as moment-tz]
            [common.modal.view :refer [defmodal modal-v2]]
            [common.util :as util]
            [common.widgets.asset-upload :as upload]
            [common.widgets.form-field :refer [form-field hint]]
            [common.widgets.input :refer [input]]
            [manage.ad-variant.creation.feed.db :as form]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui authentication []
  (let [{requires-auth? :value on-change :on-change} (form/use-bind-control [:requires-auth?])
        api-key-type-control (form/use-bind-control [:api-key-field-type])

        api-key-control (form/use-bind-control [:api-key-field-name])
        api-key-err-msg (form/use-error-message [:api-key-field-name])

        api-secret-control (form/use-bind-control [:api-key])
        api-secret-err-msg (form/use-error-message [:api-key])]
    ($ :<>
       ($ Stack
          {:direction "row"
           :justifyContent "space-between"
           :alignItems "center"}
          ($ Stack
             {:direction "row"
              :alignItems "center"
              :gap 1}
             ($ Switch
                {:checked requires-auth?
                 :onChange #(on-change (not requires-auth?))})
             ($ Typography {:component "span"}
                "URL requires authentication"))
          (when requires-auth?
            ($ Select
               {:variant "standard"
                :color "primary"
                :value (:value api-key-type-control)
                :onChange (fn [^js e]
                            ((:on-change api-key-type-control) (.. e -target -value)))
                :sx #js {".MuiSelect-select" #js {:color "primary.main"
                                                  :py 0
                                                  ":focus" #js {:backgroundColor "unset"}}

                         "::before, ::after" #js {:content "unset"}}}
               (for [{:keys [value label]} form/api-key-field-type-options]
                 ($ MenuItem {:key value :value value} label)))))

       (when requires-auth?
         ($ :<>
            ($ form-field
               {:label "API key"
                :required? true
                :err-msg api-key-err-msg}
               ($ input api-key-control))
            ($ form-field
               {:label "API secret"
                :required? true
                :err-msg api-secret-err-msg}
               ($ input api-secret-control)))))))

(defui schedule []
  (let [{checked :value on-change :on-change} (form/use-bind-control [:schedule-import?])
        time-control (form/use-bind-control [:time])
        timezone-control (form/use-bind-control [:timezone])]
    ($ Stack
       {:direction "row"
        :justifyContent "space-between"
        :alignItems "center"}
       ($ Stack
          {:direction "row"
           :alignItems "center"
           :gap 1}
          ($ Switch
             {:checked checked
              :onChange #(on-change (not checked))})
          ($ Typography {:component "span"}
             "Repeat import daily"))
       (when checked
         ($ Stack
            {:direction "row"
             :alignItems "center"
             :gap 2}
            ;; moment-tz date-lib-instance is required for timezone support
            ($ LocalizationProvider {:date-adapter AdapterMoment
                                     :date-lib-instance moment-tz
                                     :adapter-locale "en-US"}
               ($ TimePicker
                  (merge time-control
                         {:timezone (:value timezone-control)
                          :slots #js {:openPickerIcon (uix/as-react
                                                       (fn []
                                                         ($ Icon "arrow_drop_down")))}
                          :slotProps #js {:textField (fn [props]
                                                       #js {:variant "standard"
                                                            :size "small"
                                                            :sx #js {:width "60px"
                                                                     ".MuiInput-root" #js {"::before, ::after" #js {:content "unset"}}
                                                                     ".MuiInput-input" #js {:padding 0}
                                                                     ".MuiInputAdornment-root" #js {:ml 0
                                                                                                    ".MuiButtonBase-root" #js {:padding 0
                                                                                                                               :mr 0}
                                                                                                    ".MuiIcon-root" (when (.-focused props)
                                                                                                                      #js {:transform "rotate(180deg)"})}}})}})))
            ($ Select
               {:variant "standard"
                :color "primary"
                :value (:value timezone-control)
                :onChange (fn [^js e]
                            ((:on-change timezone-control) (.. e -target -value)))
                :sx #js {".MuiSelect-select" #js {:py 0
                                                  ":focus" #js {:backgroundColor "unset"}}

                         "::before, ::after" #js {:content "unset"}}}
               (for [tz util/timezones]
                 ($ MenuItem {:key tz :value tz} tz))))))))

(defui modal-content []
  (uix/use-effect (fn []
                    (rf/dispatch [:form.ad-variants.feed/init-form])
                    (fn []
                      (rf/dispatch [:form.ad-variants.feed/destroy])))
                  [])
  (let [{on-change-url :on-change :as url-control} (form/use-bind-control [:url])

        on-upload (fn [value name]
                    (on-change-url value)
                    (rf/dispatch [:form.ad-variants.feed/on-change [:name] name])
                    (rf/dispatch [:form.ad-variants.feed/on-change [:requires-auth?] false])
                    (rf/dispatch [:form.ad-variants.feed/on-change [:schedule-import?] false]))

        external-url? (use-subscribe [:form.ad-variants.feed/external-url?])]
    ($ Stack {:gap 3
              :sx #js {:py 2
                       :minWidth 564}}
       ($ form-field
          ($ upload/upload
             {:enableEdit false
              :enablePreview false
              :resumable? true
              :onChange on-upload
              :path [::asset]
              :extensions ".json, .csv"})
          ($ hint "Supported formats: .csv, .json."))

       ($ Divider "OR")

       ($ form-field
          {:label "Import from URL"
           :err-msg (form/use-error-message [:url])}
          ($ input
             (merge url-control
                    {:on-change (fn [value]
                                  (on-change-url value)
                                  (rf/dispatch [:form.ad-variants.feed/on-change [:name] nil]))
                     :endAdornment ($ InputAdornment {:position "end"}
                                      ($ IconButton {:onClick #(on-change-url "")}
                                         ($ Icon "cancel")))
                     :sx #js {:pr 0}})))

       (when external-url?
         ($ :<>
            ($ authentication)
            ;; disabled until we figure out if we want to update ad-variants
            ;; automatically on feed updates.
            #_($ schedule))))))

(defui modal-footer []
  ($ Stack {:direction "row" :gap 1}
     ($ Button {:variant "text"
                :on-click #(rf/dispatch [:modal/close])
                :sx #js {:color "text.primary"}}
        "Cancel")
     ($ Button {:variant "contained"
                :disabled (not (use-subscribe [:form.ad-variants.feed/url-changed?]))
                :onClick #(rf/dispatch [:form.ad-variants.feed/submit])}
        "Import")))

(defmodal import-feed :ad-variant/import-feed
  []
  ($ modal-v2
     {:title "Import feed"
      :footer ($ modal-footer)}
     ($ modal-content)))
